const DATOS_GENERALES = '1'
const DATOS_BANCARIOS = '2'
const DATOS_IMPOSITIVOS = '3'
const DATOS_GENERALES_NAME = 'generalData'
const DATOS_BANCARIOS_NAME = 'paymentData'
const DATOS_IMPOSITIVOS_NAME = 'taxData'

export default {
  DATOS_GENERALES: DATOS_GENERALES,
  DATOS_BANCARIOS: DATOS_BANCARIOS,
  DATOS_IMPOSITIVOS: DATOS_IMPOSITIVOS,
  DATOS_GENERALES_NAME: DATOS_GENERALES_NAME,
  DATOS_BANCARIOS_NAME: DATOS_BANCARIOS_NAME,
  DATOS_IMPOSITIVOS_NAME: DATOS_IMPOSITIVOS_NAME
}



// WEBPACK FOOTER //
// ./src/config/company_stage.js